import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { API } from '../config';

const InventoryComponent = () => {
  const [items, setItems] = useState([]);
  const [search, setSearch] = useState('');
  const [loading, setLoading] = useState(true);
  const [groupByDomain, setGroupByDomain] = useState(true);

  useEffect(() => {
    fetchItems();
  }, []);

  const fetchItems = async (query = '') => {
    try {
      setLoading(true);
      const params = query ? `?search=${encodeURIComponent(query)}` : '';
      const response = await axios.get(`${API}/items/${params}`);
      setItems(response.data.items || []);
    } catch (err) {
      console.error('Error:', err);
    } finally {
      setLoading(false);
    }
  };

  const handleSearch = (e) => {
    const q = e.target.value;
    setSearch(q);
    if (q.length >= 2 || q.length === 0) {
      fetchItems(q);
    }
  };

  const grouped = items.reduce((acc, item) => {
    const key = item.domain_name || item.domain_id;
    if (!acc[key]) acc[key] = [];
    acc[key].push(item);
    return acc;
  }, {});

  return (
    <div className="space-y-6" data-testid="inventory-component">
      <div className="text-center">
        <h2 className="text-2xl font-bold text-gray-900">Mi Inventario</h2>
        <p className="text-gray-600">Todo lo que gestionas en CUALAPP, en un solo lugar</p>
      </div>

      {/* Search Bar */}
      <div className="relative">
        <div className="absolute inset-y-0 left-0 pl-4 flex items-center pointer-events-none">
          <svg className="h-5 w-5 text-gray-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
          </svg>
        </div>
        <input
          type="text"
          value={search}
          onChange={handleSearch}
          placeholder="Buscar en todo tu inventario..."
          data-testid="inventory-search"
          className="w-full pl-12 pr-4 py-3 border border-gray-300 rounded-xl shadow-sm focus:ring-2 focus:ring-purple-500 focus:border-purple-500 text-base"
        />
      </div>

      {/* View toggle */}
      <div className="flex items-center justify-between">
        <p className="text-sm text-gray-500">{items.length} elemento{items.length !== 1 ? 's' : ''} en total</p>
        <button
          onClick={() => setGroupByDomain(!groupByDomain)}
          className="text-sm text-purple-600 hover:text-purple-800 font-medium"
          data-testid="toggle-group-btn"
        >
          {groupByDomain ? 'Ver lista plana' : 'Agrupar por dominio'}
        </button>
      </div>

      {loading ? (
        <div className="text-center py-12 text-gray-500">Cargando inventario...</div>
      ) : items.length === 0 ? (
        <div className="text-center py-12">
          <p className="text-gray-500 text-lg">Tu inventario esta vacio</p>
          <p className="text-sm text-gray-400 mt-2">Crea Cual-Acciones en tus Dominios para llenar tu inventario</p>
        </div>
      ) : groupByDomain ? (
        <div className="space-y-6">
          {Object.entries(grouped).map(([domain, domainItems]) => (
            <div key={domain}>
              <h3 className="text-sm font-semibold text-gray-500 uppercase tracking-wider mb-3 border-b pb-1">{domain} ({domainItems.length})</h3>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
                {domainItems.map((item) => (
                  <div key={item.id} className="bg-white rounded-lg shadow-sm border border-gray-200 p-4 hover:shadow-md transition-shadow" data-testid={`inventory-item-${item.id}`}>
                    <div className="flex items-start space-x-3">
                      <span className="text-2xl">{item.icon}</span>
                      <div className="flex-1 min-w-0">
                        <p className="font-medium text-gray-900">{item.name}</p>
                        {item.description && <p className="text-xs text-gray-500 mt-0.5">{item.description}</p>}
                        <div className="mt-2 space-y-1">
                          {Object.entries(item.data || {}).slice(0, 3).map(([key, val]) => (
                            <p key={key} className="text-xs text-gray-600">
                              <span className="font-medium">{key.replace(/_/g, ' ')}:</span> {String(val)}
                            </p>
                          ))}
                          {Object.keys(item.data || {}).length > 3 && (
                            <p className="text-xs text-gray-400">+{Object.keys(item.data).length - 3} campos mas</p>
                          )}
                        </div>
                        <p className="text-xs text-gray-400 mt-2">
                          {new Date(item.created_at).toLocaleDateString('es-ES')}
                        </p>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
      ) : (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-3">
          {items.map((item) => (
            <div key={item.id} className="bg-white rounded-lg shadow-sm border border-gray-200 p-4 hover:shadow-md transition-shadow" data-testid={`inventory-item-${item.id}`}>
              <div className="flex items-start space-x-3">
                <span className="text-2xl">{item.icon}</span>
                <div className="flex-1 min-w-0">
                  <p className="font-medium text-gray-900">{item.name}</p>
                  <span className="text-xs text-purple-600 bg-purple-50 px-1.5 py-0.5 rounded">{item.domain_name}</span>
                  <div className="mt-2 space-y-1">
                    {Object.entries(item.data || {}).slice(0, 2).map(([key, val]) => (
                      <p key={key} className="text-xs text-gray-600">
                        <span className="font-medium">{key.replace(/_/g, ' ')}:</span> {String(val)}
                      </p>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};


// User Economy Profile Component


export default InventoryComponent;
